import { camelizeKeys } from 'humps';
import { isString } from 'lodash-es';
import { post, validateScheme } from '@namespace/helpers';
import { PAYMENTS_COMMON_REQ_PARAMS } from '../constants';
import { apiRoutes } from './apiRoutes';
import { DepositResponseSchema, WithdrawResponseSchema } from './schemas';
import {
  DepositParams,
  DepositResponse,
  WithdrawParams,
  WithdrawResponse
} from './types';

export const withdraw = ({
  userId,
  isNodePayments,
  ...rest
}: WithdrawParams) => {
  const url = apiRoutes.withdraw({ isNodePayments, userId });

  return post<WithdrawResponse>({
    url,
    body: rest,
    ...PAYMENTS_COMMON_REQ_PARAMS
  }).then((data) => {
    validateScheme(WithdrawResponseSchema, data, { name: 'withdraw' });
    const camelized = camelizeKeys<WithdrawResponse>(data);
    // We shouldn't camelize response
    // because we should send it to the payment system as we got it from the backend
    camelized.response = isString(data.response)
      ? data.response
      : { ...(data.response as Record<string, unknown>) };

    return {
      ...camelized,
      redirectMethod: camelized.redirectMethodNew || camelized.redirectMethod
    };
  });
};

export const deposit = ({ userId, isNodePayments, ...rest }: DepositParams) => {
  const url = apiRoutes.deposit({ isNodePayments, userId });

  return post<DepositResponse>({
    url,
    body: rest,
    ...PAYMENTS_COMMON_REQ_PARAMS
  }).then((data) => {
    validateScheme(DepositResponseSchema, data, { name: 'deposit' });
    const camelized = camelizeKeys<DepositResponse>(data);
    // We shouldn't camelize response
    // because we should send it to the payment system as we got it from the backend
    camelized.response = isString(data.response)
      ? data.response
      : { ...(data.response as Record<string, unknown>) };

    return {
      ...camelized,
      redirectMethod: camelized.redirectMethodNew || camelized.redirectMethod
    };
  });
};
